__turbopack_context__.v({
  "container": "FaqSection-module__8Z9z1q__container",
});
